import { render } from "./RolesPage.vue?vue&type=template&id=4acb179a&scoped=true"
import script from "./RolesPage.vue?vue&type=script&lang=js"
export * from "./RolesPage.vue?vue&type=script&lang=js"

import "./RolesPage.vue?vue&type=style&index=0&id=4acb179a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acb179a"]])

export default __exports__